
import { JournalKeys } from '@/i18n/types';

export const journal: Record<JournalKeys, string> = {
  journal: 'Diario',
  addEntry: 'Añadir Entrada',
  editEntry: 'Editar Entrada',
  deleteEntry: 'Eliminar Entrada',
  entryTitle: 'Título de la Entrada',
  content: 'Contenido',
  moodRating: 'Valoración de Ánimo',
  tags: 'Etiquetas',
  viewDetails: 'Ver Detalles',
  createdAt: 'Creado El',
  writeJournalEntry: 'Escribir Entrada de Diario',
  journalEntryPlaceholder: '¿Cómo fue tu día?',
  dailyHighlight: 'Momento Destacado del Día (Opcional)',
  saveEntry: 'Guardar Entrada',
  journalEntries: 'Entradas',
  noJournalEntries: 'Aún no hay entradas de diario. ¡Comienza a escribir!',
  personalJournal: 'Diario Personal',
  journalDesc: 'Reflexiona sobre tu día y registra tus pensamientos.',
  editJournalEntry: 'Editar Entrada de Diario',
  deleteJournalEntry: 'Eliminar Entrada de Diario',
  deleteJournalEntryConfirm: '¿Estás seguro de que quieres eliminar esta entrada del diario? Esta acción no se puede deshacer.',
  exportJournal: 'Exportar a PDF',
  exportedOn: 'Exportado el',
  date: 'Fecha',
  highlight: 'Destacado',
  cancel: 'Cancelar',
  save: 'Guardar',
  delete: 'Eliminar',
  viewEntriesByDate: 'Ver entradas por fecha',
  entriesFor: 'Entradas para',
  noEntriesForDate: 'No hay entradas para esta fecha',
  search: 'Buscar',
  statistics: 'Estadísticas',
  searchPlaceholder: 'Buscar en tus entradas...',
  totalEntries: 'Total de Entradas',
  thisMonth: 'Este Mes',
  weeklyAverage: 'Promedio Semanal'
};
